// Hand-drawn looking SVG decorative graphics, lightweight & inline.
// All use purple/lavender brand colors with subtle animations.

export function Squiggle({ className = "", color = "#8E44AD" }) {
  return (
    <svg
      viewBox="0 0 220 30"
      className={className}
      aria-hidden
      preserveAspectRatio="none"
    >
      <path
        d="M2 15 C 30 0, 60 30, 90 15 S 150 0, 180 15 S 218 18, 218 15"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        pathLength="1"
        className="draw-line"
      />
    </svg>
  );
}

export function StarBurst({ className = "", color = "#6F2DA8", size = 80 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 80 80"
      className={`spin-slow ${className}`}
      aria-hidden
    >
      {Array.from({ length: 12 }).map((_, i) => (
        <line
          key={i}
          x1="40"
          y1="10"
          x2="40"
          y2="22"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          transform={`rotate(${i * 30} 40 40)`}
        />
      ))}
      <circle cx="40" cy="40" r="5" fill={color} />
    </svg>
  );
}

export function DottedArc({ className = "", color = "#6F2DA8" }) {
  return (
    <svg viewBox="0 0 200 100" className={className} aria-hidden>
      <path
        d="M10 80 Q 100 -10 190 80"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeDasharray="2 8"
      />
    </svg>
  );
}

export function Heart({ className = "", color = "#8E44AD", size = 26 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      className={`pulse-soft ${className}`}
      aria-hidden
    >
      <path
        d="M12 21s-7-4.35-9.5-9C.5 7.5 4 3 8 3c2 0 3.5 1 4 2.5C12.5 4 14 3 16 3c4 0 7.5 4.5 5.5 9-2.5 4.65-9.5 9-9.5 9z"
        fill="none"
        stroke={color}
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export function JointDrawing({ className = "", color = "#6F2DA8", size = 110 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 120 120" className={className} aria-hidden>
      <circle cx="60" cy="60" r="44" fill="none" stroke={color} strokeWidth="1" strokeDasharray="3 5" />
      <path
        d="M40 50 Q 50 35 60 50 T 80 50"
        stroke={color}
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
      <path
        d="M40 70 Q 50 85 60 70 T 80 70"
        stroke={color}
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
      />
      <circle cx="60" cy="60" r="6" fill={color} />
    </svg>
  );
}

export function Sparkle({ className = "", color = "#C7A5D9", size = 18 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" className={`twinkle ${className}`} aria-hidden>
      <path
        d="M12 2 L13.5 10.5 L22 12 L13.5 13.5 L12 22 L10.5 13.5 L2 12 L10.5 10.5 Z"
        fill={color}
      />
    </svg>
  );
}

export function Ribbon({ className = "", color = "#8E44AD" }) {
  return (
    <svg viewBox="0 0 360 60" className={className} aria-hidden preserveAspectRatio="none">
      <path
        d="M2 30 C 60 10, 120 50, 180 30 S 300 10, 358 30"
        stroke={color}
        strokeWidth="2.5"
        fill="none"
        strokeLinecap="round"
        pathLength="1"
        className="draw-line"
      />
      <circle cx="2" cy="30" r="3" fill={color} />
      <circle cx="358" cy="30" r="3" fill={color} />
    </svg>
  );
}

export function Bone({ className = "", color = "#8E44AD", size = 60 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden>
      <path
        d="M14 22 a8 8 0 1 1 6 14 l24 0 a8 8 0 1 1 6 -14 a8 8 0 1 1 -6 -14 l-24 0 a8 8 0 1 1 -6 14 z"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinejoin="round"
        transform="rotate(-30 32 32)"
      />
    </svg>
  );
}
